module.exports = __webpack_public_path__ + "getimgai-3-dc000d7b274b4aa6be79f8e8048f3b4c.webp";